import React from 'react';

export default function ServiceImagePicker({ inputRef, previews, disabled, isDragActive, onSelect, onDrop, onDragOver, onDragLeave, onRemove }) {
  const openPicker = () => {
    if (!disabled && inputRef.current) inputRef.current.click();
  };
  return (
    <>
      <div className={`sd-upload-zone ${isDragActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
        role="button" tabIndex={disabled ? -1 : 0} aria-disabled={disabled}
        aria-label="Servis fotoğrafları seç" onClick={openPicker}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openPicker(); }
        }}
        onDragOver={event => { event.preventDefault(); if (!disabled) onDragOver(event); }}
        onDragLeave={onDragLeave}
        onDrop={event => { event.preventDefault(); if (!disabled) onDrop(event); }}>
        <i className="fa fa-cloud-upload" aria-hidden="true" />
        <div><strong>Görselleri buraya bırakın</strong><small>veya cihazınızdan seçin · görsel başına en fazla 4 MB</small></div>
        <input ref={inputRef} type="file" accept="image/*" multiple disabled={disabled}
          aria-label="Servis fotoğraf dosyaları" style={{ display: 'none' }}
          onClick={event => event.stopPropagation()} onChange={onSelect} />
      </div>
      {previews.length > 0 && (
        <div className="sd-image-preview-list">
          {previews.map((preview, index) => (
            <div className="sd-image-preview" key={preview.url}>
              <img src={preview.url} alt={preview.name} />
              <button type="button" disabled={disabled} title="Seçimden çıkar"
                aria-label={`${preview.name} seçimden çıkar`} onClick={() => onRemove(index)}>
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
